import "./App.css";
import Home from "./page/home/home.js";

function App() {
	return (
		<div className="App">
			<Home></Home>
		</div>
	);
}

export default App;
